import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import CulturalPartner from './CulturalPartner';
import EnableSection from './EnableSection';
import EngageSection from './EngageSection';
import ElevateSection from './ElevateSection';
import Footer from '../../components/Footer';

const Services = () => {
  const location = useLocation();

  // Refs to scrollable sections
  const enableRef = useRef(null);
  const engageRef = useRef(null);
  const elevateRef = useRef(null);

  useEffect(() => {
    const hash = location.hash.replace('#', '');

    // Delay scrolling to ensure the DOM is rendered
    setTimeout(() => {
      if (hash === 'enable' && enableRef.current) {
        enableRef.current.scrollIntoView({ behavior: 'smooth' });
      } else if (hash === 'engage' && engageRef.current) {
        engageRef.current.scrollIntoView({ behavior: 'smooth' });
      } else if (hash === 'elevate' && elevateRef.current) {
        elevateRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // Delay may vary; adjust if needed
  }, [location]);

  return (
    <div className='!bg-white '>
      <CulturalPartner />

      <div ref={enableRef} id="enable" style={{ scrollMarginTop: '100px' }}>
        <EnableSection />
      </div>

      <div ref={engageRef} id="engage" style={{ scrollMarginTop: '100px' }}>
        <EngageSection />
      </div>

      <div ref={elevateRef} id="elevate" style={{ scrollMarginTop: '100px' }}>
        <ElevateSection />
      </div>

      <Footer />
    </div>
  );
};

export default Services;
